import React, { useEffect, useState } from 'react'
import PlantillaScreen from '../../helpers/PlantillaScreen'
import { FiltroListadoPrecio } from './FiltroListadoPrecio'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { useBoxFiltros } from '../../CreditoyCobranza/ReporteCobranza/Helper/useBox';
import { GetKeyArray } from '../../../Helpers/GetKey';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { LoaderScreen } from '../../components/LoaderScreen';
import { TablaUsadosContainer } from './TablaUsadosContainer';
import { FiltroBuscadoListadoPrecio } from './FiltroBuscadorListadoPrecio';

export const ListadoPrecioScreen = () => {
    const history = useHistory();
    const [filtroEstado, setFiltroEstado] = useState(false);
    const [keyFiltrado, setKeyFiltrado] = useState("")
    const [boxstate, setBoxState] = useBoxFiltros();
    const [state, setState] = useState({
        resumen: {},
        data: [],
    });
    const [data, setData] = useState([])
    const [datafiltro, setDatafiltro] = useState([])
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [selectedFilters, setSelectedFilters] = useState({
        sucursal: [],
        promocion: [],
        estatus: [],
        ejercicio: [],
        modelo: [],
        hp: [],
        tipo: [],
        antiguedad: [],
    });

    const reseteoFiltro = () => {
        // console.log("hola")
        // setSelectedFilters({
        //     ...selectedFilters,
        //     sucursal: [],
        //     promocion: [],
        //     estatus: [],
        //     ejercicio: [],
        //     modelo: [],
        //     hp: [],
        //     tipo: [],
        //     antiguedad: [],
        // })
    };


    useEffect(() => {
        ObtenerListado()
    }, []);

    const ObtenerListado = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `Inventario/ListadoFiltro`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result);
                // setDatafiltro(result);


            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
    }


    const onGeneraPDF = (datos) => {
        const mdl = (datos);
        setLoader({ ...loader, mostrar: true });
        request
            .post("Inventario/ImprimirPDF", mdl)
            // .get(`CotizacionUsados/ImprimirCotizacionPDF?idinventario=2`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onGeneraExcel = (datos) => {
        setLoader({ ...loader, mostrar: true });
        const mdl = (datos);
        request
        .post("Inventario/ImprimirExcel", mdl)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const handleFiltrar = async () => {
        setFiltroEstado(true); // Activa la señal para la tabla
    };

    return (

        <PlantillaScreen
            titulo={"INVENTARIO DE MAQUINARIA SEMINUEVA"}
            className_main={1}
            className={"listado-precios-main-screen"}
        >
            <LoaderScreen loader={loader} />
            <div className='Contenedor-lista-precios-usado'>
                <div className="listado-precios-botones-pagina-container">
                    <div
                        className="listado-precios-actions-regresar"
                        onClick={() => history.push("/Usados/Main")}
                    >
                        <ArrowBackIcon />
                        Regresar
                    </div>
                    <FiltroListadoPrecio
                        data={data}
                        datafiltro={datafiltro}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        setDatafiltro={setDatafiltro}
                        filtrar={filtroEstado}
                        setFiltrar={setFiltroEstado}
                        keyFiltrado={keyFiltrado}
                    />
                    <div className="buttons">
                        <button className="PDF"
                            onClick={() =>
                                onGeneraPDF(datafiltro)
                            }
                            style={{ backgroundColor: '#940404' }}>
                            PDF
                        </button>
                        <button className="Excel"
                            onClick={() =>
                                onGeneraExcel(datafiltro)
                            }
                            style={{ backgroundColor: '#035917' }}>
                            Excel
                        </button>
                    </div>
                </div>
                {/* <FiltroListadoPrecioNuevo
                    data={data}
                    datafiltro={datafiltro}
                    setDatafiltro={setDatafiltro}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    keyFiltrado={keyFiltrado}
                /> */}
                <FiltroBuscadoListadoPrecio
                    data={data}
                    datafiltro={datafiltro}
                    setDatafiltro={setDatafiltro}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    keyFiltrado={keyFiltrado}
                />
                <TablaUsadosContainer
                    datos={datafiltro}
                    reseteoFiltro={reseteoFiltro}
                    ObtenerListado={ObtenerListado}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    setKeyFiltrado={setKeyFiltrado}
                />
            </div>
        </PlantillaScreen>
    )
}
